import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getExclusionOffice(params) {
  return request({
    url: URL.sys.getExclusionOffice,
    method: 'post',
    params
  })
}

export function saveExclusionOffice(data) {
  return request({
    url: URL.sys.saveExclusionOffice,
    method: 'post',
    data
  })
}

export function isExcludedOffice(params) {
  return request({
    url: URL.sys.isExcludedOffice,
    method: 'post',
    params
  })
}

export function areAllExcludedOffices(params) {
  return request({
    url: URL.sys.areAllExcludedOffices,
    method: 'post',
    params
  })
}
